import classNames from "classnames";
import { observer } from "mobx-react";
import React, { Component } from "react";
import { InjectedIntl, injectIntl, IntlProvider } from "react-intl";
import arrowLeft from "../../../assets/images/left-arrow.svg";
import { FLAGS } from "../../../shared/flags";
import { MainStore } from "../../../stores/MainStore";
import Image from "../../Image";
import Label from "../../Label";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
  isFooter?: boolean;
  intl: IntlProvider & InjectedIntl;
}

interface IState {}

@observer
class DetailsNavigation extends Component<IProps, IState> {
  render() {
    const { store, isFooter } = this.props;
    const { selectedState, nextState, previousState } = store;
    if (!selectedState) return null;
    const detailsNavigationClasses = classNames(
      classes.DetailsNavigation,
      isFooter ? classes.Footer : ""
    );
    const { intl } = this.props;

    return (
      <div className={detailsNavigationClasses}>
        {!isFooter && (
          <div
            className={classes.DetailsNavigationRow}
            onClick={e => store.backHome()}
          >
            <Image fitHeight src={arrowLeft} alt={"Arrow left nav"} />
            <Label bold small uppercase id={"generic.back.home"} />
          </div>
        )}
        <div className={classes.DetailsNavigationRow}>
          {!isFooter && (
            <div className={classes.DetailsNavigationState}>
              <Image small src={FLAGS[selectedState.flag]} alt={"State Flag"} />
              <Label
                extraBig
                bold
                text={intl.formatMessage({
                  id: `${selectedState.id}-label`
                })}
              />
            </div>
          )}
          {isFooter && (
            <div
              className={classes.DetailsNavigationNext}
              onClick={e => {
                if (previousState) store.openStateDetail(previousState);
              }}
            >
              <div className={classes.DetailsNavigationNextRow}>
                <Label
                  bold
                  extraSmall
                  uppercase
                  id={"generic.previous.state"}
                />
              </div>
              {previousState && (
                <div className={classes.DetailsNavigationNextRow}>
                  <Image fitHeight src={arrowLeft} alt={"Arrow left nav"} />
                  <Label bold small uppercase text={previousState.name} />
                </div>
              )}
            </div>
          )}
          <div
            className={classes.DetailsNavigationNext}
            onClick={e => {
              if (nextState) store.openStateDetail(nextState);
            }}
          >
            <div className={classes.DetailsNavigationNextRow}>
              <Label bold extraSmall uppercase id={"generic.next.state"} />
            </div>
            {nextState && (
              <div className={classes.DetailsNavigationNextRow}>
                <Label
                  bold
                  small
                  uppercase
                  text={intl.formatMessage({
                    id: `${nextState.id}-label`
                  })}
                />
                <Image fitHeight src={arrowLeft} alt={"Arrow left nav"} />
              </div>
            )}
          </div>
        </div>
        <hr />
      </div>
    );
  }
}
export default injectIntl(DetailsNavigation);
